import { Link } from 'react-router-dom';
import { toPublicPath } from "../../Utils/publicRoutes";
import { formatPriceBRL } from "../../Utils/DataFormatters";
import { useTenant } from "../../Contexts/TenantContext";

type ProductListCardProps = {
  id: string;
  image?: string;
  name: string;
  code: string;
  price: number;
};

const ProductListCard = ({ id, image, name, code, price }: ProductListCardProps) => {
  const { tenantPreference } = useTenant();
  const hideProductCode = tenantPreference?.autoGenerateProductCode === true;

  return (
    <Link to={toPublicPath(`/produtos/${id}`)}>
      <div className="w-full flex items-center bg-white shadow-md px-2 py-2.5 gap-2 border border-gray-200 hover:shadow-lg transition sm:p-4">
        {image ? (
          <img
            src={image}
            alt={name}
            className="h-9 w-9 sm:h-7 sm:w-7 object-contain flex-shrink-0"
          />
        ) : (
          <div className="h-9 w-9 sm:h-7 sm:w-7 flex-shrink-0 flex items-center justify-center bg-gray-100 text-gray-400 rounded text-[7px] text-center leading-tight">
            Sem imagem
          </div>
        )}
        <div className="flex-1 min-w-0">
          <h3 className="text-xs text-gray-800 sm:text-sm truncate">{name}</h3>
          {!hideProductCode && <h3 className="text-xs text-gray-700">{"CÓD."} {code}</h3>}
        </div>
        <span className="text-xs font-semibold text-primary-600 flex-shrink-0">{formatPriceBRL(price)}</span>
      </div>
    </Link>
  );
}

export default ProductListCard
